import { render } from "./BackButton.vue?vue&type=template&id=6793a160&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=6793a160&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-6793a160"

export default script